var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-toolbar"},[_c('router-link',{staticClass:"wikipedia logo",attrs:{"to":"/searchwikipedia"}},[_vm._v(_vm._s(_vm.$i18n('wikipedia')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }